import { StyledButtonDownload } from '../styles';
import { blockchainService } from '../../../../../services/blockchainService';

export const DownloadMerge = ({
  projectId,
  modeloDocumentId,
  modeloTopicId,
  disabled = false, // ✅ AGORA RECEBE DISABLED
}) => {

  const token = sessionStorage.getItem('Authorization');

  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };

  const handleDownload = async () => {

    // 🔒 BLOQUEIA SE ESTIVER DESABILITADO
    if (disabled) return;

    if (!projectId || !modeloDocumentId || !modeloTopicId) {
      alert('IDs inválidos para download.');
      return;
    }

    try {
      const responseMerge = await blockchainService.getMergedDocuments(
        projectId,
        modeloTopicId,
        modeloDocumentId,
        headers
      );

      if (!responseMerge || responseMerge.length === 0) {
        alert('Nenhum documento mesclado encontrado.');
        return;
      }

      const mergeId = responseMerge[0].id;

      const response = await blockchainService.downloadMergeDocument(
        mergeId,
        headers
      );

      const contentDisposition = response.headers['content-disposition'];
      let fileName = 'documento_mesclado.pdf';

      if (contentDisposition?.includes('filename=')) {
        fileName = contentDisposition
          .split('filename=')[1]
          .split(';')[0]
          .replace(/"/g, '')
          .trim();
      }

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error('❌ Erro ao baixar o PDF:', error);
      const msg = error?.response?.data?.error || 'Erro no download';
      alert(msg);
    }
  };

  return (
    <div style={{ float: 'left', marginLeft: '5px' }}>
      <StyledButtonDownload
        onClick={handleDownload}
        disabled={disabled} // ✅ AGORA PASSA DISABLED
      >
        Download
      </StyledButtonDownload>
    </div>
  );
};

export const openMergePDFInNewTab = async (mergeId) => {
  const token = sessionStorage.getItem('Authorization');
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };

  // 👉 Abre a aba imediatamente (para não ser bloqueado pelo navegador)
  const newTab = window.open('', '_blank');
  if (!newTab) {
    alert('O navegador bloqueou a abertura da nova aba.');
    return;
  }

  try {
    // 🔹 Gera assinatura (opcional)
   

    // 🔹 Faz o download via blockchainService
    const response = await blockchainService.downloadMergeDocument(mergeId, headers);

    // 🔹 Cria o Blob e redireciona a nova aba para o PDF
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    newTab.location.href = url;

  } catch (error) {
    console.error('❌ Erro ao abrir PDF:', error);
    newTab.document.write('<p>Erro ao carregar o documento.</p>');
    newTab.document.close();
    alert(error?.response?.data?.error || 'Erro ao abrir documento.');
  }
};

